import { Box, Description, TextArea, VStack } from '@revolut-internal/ui-kit'
import { FC } from 'react'

import { OpenAIChatAction } from 'lib/apiClient'

import { ParamsTable } from '../ParamsTable'
import { Prompt } from './Prompt'
import { DEBUG_ACTION_NAME } from '../consts'
import { Transactions } from './Transactions'

type Props = OpenAIChatAction

export const OpenAIChat: FC<Props> = props => {
  const { name, clientInput, clientOutput, humanReadableOutput } = props

  const { messages, promptRevision, model } = clientInput

  const modelOutput = clientOutput.model
  const modelName = (modelOutput as String) || model.name
  const modelType = modelOutput === model.name ? 'main' : 'fallback'

  const parameters = {
    ...model.parameters,
    readTimeout: model.readTimeout,
    maxRetries: model.maxRetries,
    location: model.location,
    endpointId: model.endpointId,
  }

  const [firstMessage, ...restMessages] = messages
  const promptContent = firstMessage?.content ?? ''
  const systemMessages = restMessages
    .filter(message => message.role === 'system')
    .map(({ role, content }) => `**${role}**\n${content}`)
    .join('\n\n')

  return (
    <VStack>
      <Description>
        Model: {modelType} - {modelName}
      </Description>
      <Description>Prompt revision: {promptRevision}</Description>
      <VStack>
        <Description>Model parameters:</Description>
        <Box>
          <ParamsTable data={parameters} />
        </Box>
        {systemMessages.length && (
          <>
            <Description>Client input:</Description>
            <ParamsTable
              data={{
                messages: systemMessages,
              }}
              markdown
            />
          </>
        )}
      </VStack>
      {name === DEBUG_ACTION_NAME ? (
        <>
          <Prompt defaultValue={promptContent} />
          <Transactions />
        </>
      ) : (
        <>
          <VStack>
            <Description>Prompt:</Description>
            <Box>
              <TextArea defaultValue={promptContent} disabled />
            </Box>
          </VStack>
          <Description>Client output:</Description>
          <ParamsTable
            data={humanReadableOutput ?? clientOutput}
            markdown={Boolean(humanReadableOutput)}
          />
        </>
      )}
    </VStack>
  )
}
